"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 11/02/2019
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var FavouriteEntityEnum_1 = require("./FavouriteEntityEnum");
/**
 * Object representing favourite objects of users
 *
 * @author JMr
 */


var Favourite =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Favourite, _DomainObject_1$Domai);

  /**
   * @param id
   * @param entityId id of entity which user liked
   * @param entity entity type (such as release)
   * @param userId id of the user which liked the entity
   */
  function Favourite(id, entityId, entity, userId) {
    var _this;

    _classCallCheck(this, Favourite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Favourite).call(this));
    _this.id = id;
    _this.entityId = entityId;
    _this.entity = entity;
    _this.userId = userId;
    return _this;
  }

  return Favourite;
}(DomainObject_1.DomainObject);

exports.Favourite = Favourite;

Favourite.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Favourite.name);
  return {
    id: builder.id('id'),
    entity: builder.senum('entity', FavouriteEntityEnum_1.FavouriteEntityEnum, ''),
    entityId: builder.str('entityId'),
    userId: builder.str('userId')
  };
}();